//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable import/no-cycle */
/* eslint-disable no-lonely-if */
import { ref, computed, onMounted } from '@vue/composition-api'
import { mdiClose } from '@mdi/js'
import { useUtils } from '@core/libs/i18n'
import {
  formatCurrency,
  useRouter,
  isAndroid,
  isIOS,
  openTab,
  defaultDownloadAppByOS,
  isDev,
} from '@core/utils'

import moment from 'moment'
import { getRecordingsHashid } from '@api'
import useVideoData from '@core/utils/useVideoData'

import DownloadApp from '@/views/reservation/components/download-app/DownloadApp.vue'

export default {
  components: {
    DownloadApp,
  },
  setup() {
    const { t } = useUtils()
    const { router, route } = useRouter()
    const { videoData, currentVideoData, updateVideoData } = useVideoData()

    const deepLinkVideo = ref('fanaty://video_detail/')
    const deepLinkVideoIOS = ref(`${isDev.value ? 'https://dev-console.fanaty.com' : 'https://console.fanaty.com'}/video_detail/`)

    const isOpen = ref(false)
    const isAndroidComputed = computed(() => isAndroid())
    const isIOSComputed = computed(() => isIOS())

    const formatVideoDate = videoDate => {
      const strDate = moment(videoDate).format('MMM DD')

      return strDate
    }

    const formatVideoDay = computed(() => {
      if (videoData.value && videoData.value.video) {
        if (videoData.value.video.register_date) return moment(`${videoData.value.video.register_date} ${videoData.value.video.video_start_time}`, 'YYYY-MM-DD hh:mm').format('dddd HH:mm')

        return moment(`${videoData.value.video.video_date} ${videoData.value.video.start_time}`, 'YYYY-MM-DD hh:mm').format('dddd HH:mm')
      }

      return ''
    })

    const formatVideoData = computed(() => {
      if (videoData.value && videoData.value.video) return `${formatVideoDate(videoData.value.video.register_date)} • ${videoData.value.video.facility_name} • ${videoData.value.video.field_name}`

      return ''
    })

    const openUpdate = async val => {
      isOpen.value = val
    }

    const onWatch = () => {
      // const timestamp = new Date().getTime()
      // const dLink = `${deepLinkVideo.value}${videoData.value.video.video_id}?t=${timestamp}`
      // const dLinkIOS = `${deepLinkVideoIOS.value}${videoData.value.video.video_id}?t=${timestamp}`
      const dLink = `${deepLinkVideo.value}${videoData.value.video.video_id}`
      const dLinkIOS = `${deepLinkVideoIOS.value}${videoData.value.video.video_id}`

      if (isAndroid() || isIOS()) {
        if (isIOS()) {
          // eslint-disable-next-line no-alert
          if (isDev.value) alert(`deepLinkVideoIOS value: ${dLinkIOS}`)

          openTab(dLinkIOS)
        } else {
          window.location = dLink
          isOpen.value = true
        }
      } else isOpen.value = true
    }

    const getHash = url => url.split('/r/')[1]

    const fetchRecordingHash = async hash => {
      const resp = await getRecordingsHashid(hash)
      if (resp.ok) {
        if (resp.data.video_redirect_url) {
          const hashRedirect = getHash(resp.data.video_redirect_url)
          const respRedirect = await getRecordingsHashid(hashRedirect)
          if (respRedirect.ok) {
            videoData.value.video = respRedirect.data
            router.replace({ name: 'recording', params: { hash: hashRedirect } })
          }
        } else {
          if (resp.data.video_inactive || resp.data.video_invalid) {
            router.push({
              name: 'video-not-available',
              params: {
                inactive: !!resp.data.video_inactive,
                invalid: !!resp.data.video_invalid,
              },
            })
          } else {
            Object.assign(videoData.value, currentVideoData.value)

            if (!videoData.value.video) videoData.value.video = resp.data
            else {
              const url = videoData.value.video.video_share_url ? videoData.value.video.video_share_url : videoData.value.video.share_video_url
              const isNewHash = url && getHash(url) !== hash
              if (isNewHash) videoData.value.video = resp.data
            }

            if (!videoData.value.video.video_time) videoData.value.video.video_time = resp.data.video_time

            if (!videoData.value.video.check_redirect) {
              videoData.value.video.check_redirect = false
              videoData.value.price = resp.data.video_price
              videoData.value.match = null
              videoData.value.paymentMethodsParams = null
              await updateVideoData(videoData.value)

              if (videoData.value.video.show_video_type) router.push({ name: 'views-video-quality' })
            }
          }
        }
      }
    }

    onMounted(async () => {
      const { hash } = route.value.params
      if (hash) await fetchRecordingHash(hash)
      else Object.assign(videoData.value, currentVideoData.value)
    })

    return {
      // data
      isOpen,
      videoData,

      deepLinkVideo,
      deepLinkVideoIOS,

      // methods
      formatCurrency,
      formatVideoData,
      formatVideoDay,
      defaultDownloadAppByOS,
      fetchRecordingHash,
      onWatch,
      openUpdate,

      isAndroidComputed,
      isIOSComputed,

      // themeConfig
      appLogoTitle: 'https://www.fanaty.com/images/fanaty_logo_large.png',

      t,

      icons: {
        mdiClose,
      },
    }
  },
}
